import { SnackbarService } from '../snackbar.service';

/**
 * Validates that all listed fields have a meaningful value.
 *
 * A field is considered missing when its value is `null`, `undefined`, an
 * empty string, or NaN. Pass `allowZero: false` to also reject `0` (useful
 * for "Select X" pickers where 0 is the "All" sentinel).
 *
 * On the first missing field a warning snackbar is shown and `false` is
 * returned, so callers can `if (!validateRequired(...)) return;`.
 */
export interface RequiredField {
  value: any;
  label: string;
  /** Reject `0` as missing. Defaults to `true` (0 is a valid value). */
  allowZero?: boolean;
}

export function validateRequired(
  fields: RequiredField[],
  snackbar: SnackbarService,
): boolean {
  for (const f of fields) {
    const v = f.value;
    const missing =
      v === null ||
      v === undefined ||
      v === '' ||
      (typeof v === 'number' && isNaN(v)) ||
      (f.allowZero === false && v === 0);
    if (missing) {
      snackbar.warning(`Select ${f.label}.`);
      return false;
    }
  }
  return true;
}
